import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { SlBreadcrumbService } from '../services/sl-breadcrumb.service';
import { CommonModule } from '@angular/common';
import { SlTypographyComponent } from '../../sl-typography/sl-typography.component';
import { SlLinkComponent } from '../../sl-link/sl-link.component';
import { SlGridComponent } from '../../sl-grid/sl-grid.component';
import { SlColumnComponent } from '../../sl-column/sl-column.component';

import { SlBreadcrumb } from '../models/sl-breadcrum.model';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    SlTypographyComponent,
    SlLinkComponent,
    SlGridComponent,
    SlColumnComponent,
  ],
  selector: 'sl-breadcrumb',
  templateUrl: './sl-breadcrumb.component.html',
  styleUrls: ['./sl-breadcrumb.component.scss'],
})
export class SlBreadcrumbComponent {
  breadcrumbs$: Observable<SlBreadcrumb[]>;

  constructor(private readonly breadcrumbService: SlBreadcrumbService) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs$;
  }
}
